import React from 'react';
import Login from "../../../components/pages/form/Login/Login";

const LoginPage = () => {
    return (
        <Login />
    );
};

export default LoginPage;